import { toast } from 'react-toastify';
import { RecaptchaProvider } from '../../components/provider/RecaptchaProvider.jsx';
import RecaptchaV3 from '../../components/GoogleRecaptcha-v3.jsx';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import logo from '../../assets/logo_ys.png';
import { BAlert, BButton } from '../../components/ui/generic';
import BPassword from '../../components/ui/form/BPassword';
import React, { useContext, useEffect, useState } from 'react';
import UserEmailContext from '../../context/UserEmailContext.jsx';
import { requiredField } from '../../utils';

const PasswordReset = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useContext(UserEmailContext);
  const [error, setError] = useState('');
  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();
  useEffect(() => {
    axios
      .post(`${import.meta.env.VITE_API_BASE_URL}/internal_api/password-recovery/token/verify`, {
        token,
      })
      .then((res) => {
        if (res.data.error) {
          navigate('/login');
        }
      });
  }, [navigate, token]);
  const handPasswordReset = async (data) => {
    setError('');
    if (!token || !token.startsWith('__ys')) {
      setError('Impossible de valider votre demande');
      return;
    }

    if (!data?.password) {
      setError('Merci de saisir votre mot de passe');

      return;
    }

    if (data?.password !== data?.password_confirm) {
      setError('Les mots de passe saisis sont différents. Veuillez réessayer');
      return;
    }

    await axios
      .post(`${import.meta.env.VITE_API_BASE_URL}/internal_api/password-recovery/reset`, data)
      .then((callback) => {
        if (callback?.data?.error) {
          setError(callback?.data?.message);
        } else {
          setUserEmail(callback?.data?.email);
          navigate('/login');
        }
      });
  };

  return (
    <div
      className={`bg-primary-900 to-primary-900 font-poppins flex min-h-screen w-full flex-col items-center justify-center gap-8 bg-gradient-to-l from-purple-900 px-8 text-slate-700 lg:flex-row lg:px-24`}
    >
      <div className={'flex w-full flex-col items-center gap-4 text-white'}>
        <img src={logo} alt="Logo" className={'w-fit'} />
        <div className={'flex flex-col gap-4'}>
          <p className={'text-2xl font-medium lg:text-6xl'}>Mon espace candidat</p>
          <p className={'font-medium lg:text-4xl'}>Bienvenue sur votre portail</p>
        </div>
      </div>
      <div className={`flex w-full max-w-md items-center justify-center rounded bg-white p-4 shadow`}>
        <RecaptchaProvider>
          <form onSubmit={handleSubmit(handPasswordReset)} className={'flex w-full flex-col gap-2 px-6'}>
            <p className={'text-lg font-medium'}>Veuillez définir votre mot de passe</p>
            <input {...register('token')} hidden defaultValue={token} className={`rounded border p-2`} />
            <BPassword
              name={'password'}
              label={'Mot de passe'}
              placeholder="Mot de passe"
              {...register('password', {
                required: { value: true, message: requiredField },
                minLength: { value: 6, message: 'Le mot de passe doit contenir au moins 6 caractères' },
              })}
            />
            {errors.password && <p className={'text-sm text-red-600'}>{errors.password.message}</p>}
            <BPassword
              name={'password_confirm'}
              label={'Confirmation du mot de passe'}
              placeholder="Mot de passe"
              {...register('password_confirm', {
                required: { value: true, message: requiredField },
                minLength: { value: 6, message: 'Le mot de passe doit contenir au moins 6 caractères' },
              })}
            />
            {errors.password_confirm && <p className={'text-sm text-red-600'}>{errors.password_confirm.message}</p>}

            <RecaptchaV3 setValue={setValue} />
            <div>
              <BButton isDisabled={isSubmitting} isProcessing={isSubmitting} type={'submit'} label={'Envoyer'} />
            </div>
            {error && <BAlert color={'error'}>{error}</BAlert>}

            <p className={`text-end text-sm text-gray-400`}>
              Déjà client ? connectez vous{' '}
              <Link className={`text-blue-500`} to={`/login`}>
                ici
              </Link>
            </p>
          </form>
        </RecaptchaProvider>
      </div>
    </div>
  );
};

export default PasswordReset;
